export enum ShapesModules {
  "shapesList" = "shapesList",
  "allShapesByCategory" = "allShapesByCategory",
}
